import { useEffect, useRef, useState } from "react";
import { Player } from 'media-stream-player';
import "./ClawCameraFeeds.scss";

const BasicMachineCameraFeed = ({ machineID, cameraId = 'front', monochrome = false, cameraYOffsetLevel = 5 }) => {
    const feedHolderRef = useRef(null);
    const [cameraYOffset, setCameraYOffset] = useState(0);
    // Define camera feeds for this machine
    const cameraFeeds = {
        1: {
            front: 'clawcam1.twitchcampaignstudio.com',
            top: 'clawcam2.twitchcampaignstudio.com'
        },
        2: {
            front: 'clawcam3.twitchcampaignstudio.com',
            top: 'clawcam4.twitchcampaignstudio.com'
        }
    };

    const currentFeed = cameraFeeds[machineID]?.[cameraId];

    useEffect(() => {
        if (!feedHolderRef.current) {
            return;
        }
        const updateCameraYOffset = () => {
            const feedScale = feedHolderRef.current.clientWidth / 600;
            const offsetLevel = Math.max(1, Math.min(5, Number(cameraYOffsetLevel) || 5));
            setCameraYOffset(45 * (5 - offsetLevel) * feedScale);
        };
        updateCameraYOffset();
        const observer = new ResizeObserver(updateCameraYOffset);
        observer.observe(feedHolderRef.current);
        return () => observer.disconnect();
    }, [cameraYOffsetLevel]);

    return (
        <div
            ref={feedHolderRef}
            className={`basic-claw-feed-holder${monochrome ? ' monochrome' : ''}`}
            style={{ '--camera-y-offset': `${cameraYOffset}px` }}
        >
            {currentFeed && (
                <Player
                    key={`${machineID}-${cameraId}-${currentFeed}`}
                    hostname={currentFeed}
                    initialFormat="RTP_H264"
                    secure
                    autoPlay
                    autoRetry
                />
            )}
        </div>
    );
};

export default BasicMachineCameraFeed;
